import { useState } from "react";
import { Toaster } from "react-hot-toast";
import { NavBar } from "../../themes/components/Navbar";
import { Sidebar } from "../../themes/components/Sidebar";
import GaHorizontal from '../../themes/assets/ga_logo.png';
import { ModalNotificacao } from "../../themes/components/ModalNotificacao";
import { useEffectOnce } from "react-use";
import { useLocation } from 'react-router-dom';

export function StartScreen() {
    let location: any = useLocation();
    const [showModalNotifi, setShowModalNotifi] = useState<boolean>(false);

    useEffectOnce(() => {
        if (location.state !== undefined && location.state.from !== undefined && location.state.from === "/login"){
            setShowModalNotifi(true);
        }
    })
    
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-startscreen">
                    <NavBar />
                    <div className="logo-cliente-start-screen">
                    <img src={GaHorizontal} alt="Logo Geraldo Araújo" style={{ width: '95%', opacity: '0.2', borderRadius: '0.2em', padding: '0.4em 0 0.3em 0', backgroundColor: 'white' }} />
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
    );
  }